import fetchRetry from 'fetch-retry';

const fetch = fetchRetry(global.fetch, {
  retries: 1,
  retryDelay: 1000,
  retryOn: [500, 501, 502, 503, 504],
});

export default fetch;
